import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { LogIn } from "lucide-react";
import AuthLayout from "@/components/AuthLayout";
import SignInForm from "@/components/auth/SignInForm";
import { safeReturnTo } from "@/lib/authReturnTo";

export default function Login() {
  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const organisationSlug = params.get("org") || "";
  const invitationId = extractInvitationId(safeReturnTo());
  const selector = useMemo(() => {
    if (organisationSlug) return { organisation_slug: organisationSlug };
    if (invitationId) return { invitation_id: invitationId };
    return {};
  }, [organisationSlug, invitationId]);
  const returnTo = safeReturnTo();

  const handleAuthenticated = async () => {
    window.location.href = returnTo;
  };

  const handleRegistered = async () => {
    window.location.href = returnTo;
  };

  return (
    <AuthLayout
      icon={LogIn}
      title="Welcome back"
      subtitle={organisationSlug ? `Sign in to ${organisationSlug}` : invitationId ? "Sign in to continue to your invitation" : "Log in to your account"}
      footer={
        <>
          Don't have an account?{" "}
          <Link to={invitationId ? `/accept-invitation/${encodeURIComponent(invitationId)}` : "/register"} className="text-primary font-medium hover:underline">
            {invitationId ? "Open your invitation" : "Create one"}
          </Link>
        </>
      }
    >
      <SignInForm selector={selector} returnTo={returnTo} onAuthenticated={handleAuthenticated} onRegistered={handleRegistered} />
    </AuthLayout>
  );
}

function extractInvitationId(path) {
  const match = String(path || "").match(/^\/accept-invitation\/([^/?#]+)/);
  return match ? decodeURIComponent(match[1]) : "";
}
